/**
 * contains the abi and contract address
*/

class GuildsContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "name",
				"type": "bytes32"
			}
		],
		"name": "syncClockMaster",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "name",
				"type": "bytes32"
			}
		],
		"name": "syncClockSlave",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "index",
				"type": "bytes32"
			}
		],
		"name": "ClockSyncMaster",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "index",
				"type": "bytes32"
			}
		],
		"name": "ClockSyncSlave",
		"type": "event"
	}
        ];

        this.contractAddress = '0x17eafcd1dc39c8d78ff165e1dbd0fe9e82afbdc2';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildsContract;
